
import { Clock } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useTranslation } from "react-i18next";

export const HistoryTab = () => {
  const { t } = useTranslation('offerManagement');
  
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('history.title')}</CardTitle>
        <CardDescription>
          {t('history.description')}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center gap-3 p-4 border rounded-lg">
            <Clock className="h-5 w-5 text-muted-foreground" />
            <div>
              <p className="font-medium">{t('history.noHistory')}</p>
              <p className="text-sm text-muted-foreground">
                {t('history.noHistoryDesc')}
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
